import { useEffect, useState } from 'react';
import { onNewVersion, reloadForNewVersion } from '../../utils/versionCheck';

/**
 * Bottom-right toast that appears when the deployed version differs from the
 * version baked into the running bundle. Click "Reincarca" → hard reload with
 * a cache-busting query string.
 *
 * Dismissable, but the version check keeps running — if the user dismisses and
 * a NEWER deploy happens, the banner reappears.
 */
export default function VersionBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    return onNewVersion(() => setShow(true));
  }, []);

  if (!show) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-50 max-w-sm bg-indigo-600 text-white rounded-xl shadow-2xl px-4 py-3 flex items-start gap-3"
    >
      <div className="flex-1 text-sm">
        <div className="font-semibold mb-1">Versiune nouă disponibila</div>
        <div className="text-indigo-100 text-xs">
          Reincarca pagina pentru a folosi cea mai recenta versiune.
        </div>
      </div>
      <div className="flex flex-col gap-1 shrink-0">
        <button
          type="button"
          onClick={reloadForNewVersion}
          className="px-3 py-1 bg-white text-indigo-700 rounded-md text-xs font-semibold hover:bg-indigo-50 transition"
        >
          Reincarca
        </button>
        <button
          type="button"
          onClick={() => setShow(false)}
          className="px-3 py-1 text-indigo-100 text-xs hover:text-white transition"
        >
          Mai tarziu
        </button>
      </div>
    </div>
  );
}
